import { createAsyncThunk } from '@reduxjs/toolkit';

import { getPrimaryConnectedShopifyChannelId } from '../../components/teammates/views/Channels/helpers/salesChannelState';
import { pullProductsForSalesChannel } from './pullProductsForSalesChannel';

export const pullProducts = createAsyncThunk(
  'salesChannels/pullProducts',
  async (_, {
    dispatch,
    getState,
    extra: {
      Logger,
      Toast,
      showDialog,
      utils,
      localization: l10n,
    },
  }) => {
    const salesChannelId = getPrimaryConnectedShopifyChannelId(getState().user?.team);

    if (!salesChannelId) {
      Logger.error(
        new Error('pullProducts: no connected Shopify sales channel'),
        {},
        ['ConnectShopifyChPullFailed', { reason: 'no_channel' }],
      );
      return;
    }

    try {
      await dispatch(pullProductsForSalesChannel({ salesChannelId })).unwrap();
      Toast(l10n.DIALOGS.PULL_PRODUCTS.SYNC_IN_PROGRESS);
    } catch (error) {
      const errorSubcode = utils.getDataFromResponceError(error, 'subcode');

      if (errorSubcode === 'HasAttachingAssetsError') {
        showDialog({
          title: l10n.DIALOGS.SYNC_PRODUCTS_ERROR.TITLE,
          text: l10n.DIALOGS.SYNC_PRODUCTS_ERROR.TEXT,
          textBtnOk: l10n.DIALOGS.SYNC_PRODUCTS_ERROR.BTN_OK,
          textBtnCancel: null,
        });
      } else {
        Toast(l10n.DIALOGS.PULL_PRODUCTS.SYNC_FAILED, {
          type: 'error',
          autoClose: false,
          onOk: () => dispatch(pullProducts()),
          btnOkValue: l10n.DIALOGS.PULL_PRODUCTS.BTN_TRY_AGAIN,
        });
      }
    }
  },
);
